import { styled } from 'styled-components';
import Text from '@ingka/text';
import Hyperlink from '@ingka/hyperlink';
import designTokens from '@ingka/variables/design-tokens';
import { Trans, useTranslation } from 'react-i18next';
import { translationExists } from '../helpers/translationsHelper';
import { selectAppOperation } from '../reducers/selectors';
import { useStateSelector } from '../store';

const StyledText = styled(Text)`
  &&& {
    margin-top: 2.5rem;
  }
`;

const StyledLink = styled(Hyperlink)`
  font-weight: ${designTokens.fontWeightBold};
`;

const { useExtendedFooterText } =
  CSS_CONFIG.configurableTranslationKeys.services;

const ExtendedFooterText: React.FC = () => {
  const { t, i18n } = useTranslation();
  const appOperation = useStateSelector(selectAppOperation);

  const showExtendedFooterText = useExtendedFooterText.operations.some(
    (value) => value === 'ALL_OPERATIONS' || value === appOperation,
  );

  if (!showExtendedFooterText) {
    return null;
  }

  return (
    <>
      <StyledText tagName="h3" textStyle="Heading.S">
        {t('pages.services.footerTitle')}
      </StyledText>
      <Text tagName="p" textStyle="Body.M">
        <Trans
          i18n={i18n}
          i18nKey="pages.services.footerDescription"
          components={
            translationExists('pages.services.footerDescriptionLink', t)
              ? [
                  <StyledLink
                    key="footerDescriptionLink"
                    url={t('pages.services.footerDescriptionLink')}
                    newWindow
                    rel="noopener noreferrer"
                  >
                    FOOTER LINK
                  </StyledLink>,
                ]
              : []
          }
        />
      </Text>
    </>
  );
};

export default ExtendedFooterText;
